// Let's try to keep the convention of this file to camelcase(name of rails helper path)

export const advisoryPrescriptionAdminPath = (consultationId, memberId) =>
  `/members/${memberId}/consultations/${consultationId}/advisory_prescription_pdf`;
